import axios from "../axios.config";

const state = {
  list_integration: [],
};

const actions = {
  async loadListIntegration({ commit }) {
    try {
      const { data } = await axios.get("/integration/");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_LIST_INTEGRATION", data.data);
    } catch (error) {
      throw new Error(error);
    }
  },

  async saveIntegration({ commit }, params) {
    try {
      const { data } = await axios.post(`/integration/`, params);
      if (data.success === false) {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error);
    }
  },

  async attIntegration({ commit }, params) {
    try {
      const { data } = await axios.put(`/integration/` + params.id, params);
      if (data.success === false) {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error);
    }
  },

  async deleteIntegrationConfig({ commit }, params) {
    try {
      const { data } = await axios.delete(`/integration/` + params.id);
      if (data.success === false) {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const mutations = {
  SET_LIST_INTEGRATION: (state, data) => {
    state.list_integration = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
